// @flow

import * as React from "react";

import RichTextContent from "../molecules/RichTextContent";
import MediaGallery from "./MediaGallery";
import TileRow from "./TileRow";
import ImageText from "../molecules/ImageText";
import Accordions from "./Accordions";
import IconRow from "../molecules/IconRow";
import RTMForm from "./RTMForm";
import Leaderboard from "./Leaderboard";
import addACFData from "../../utils/addACFData";
import getContentReferenceTileProps from "../../utils/getContentReferenceTileProps";
import WhatsOn from "./WhatsOn";

type PropsType = {
    components: Array<any>,
    isContentPageComponent?: boolean,
};

const ComponentBuilder = ({ components }: PropsType): React.Node => {
    const renderSingleComponent = (component: any): React.Node => {
        const componentData = component.component;
        const classList = [
            "component-builder__component__inner col-xs-12 col-md-offset-1 col-lg-offset-2",
        ];
        switch (component.acf_fc_layout) {
            case "rich_text_content": {
                classList.push("col-md-10 col-lg-8");
                return (
                    <div className={classList.join(" ")}>
                        <RichTextContent
                            html={componentData.html}
                            background={componentData.background}
                            className="component"
                            isContentPageComponent
                        />
                    </div>
                );
            }
            case "tile_row": {
                classList.push("col-md-11  col-lg-9");
                return (
                    <div className={classList.join(" ")}>
                        <TileRow
                            title={componentData.title}
                            description={componentData.description}
                            tiles={componentData.tiles}
                        />
                    </div>
                );
            }
            case "image_text": {
                classList.push("col-md-10 col-lg-9");
                return (
                    <div className={classList.join(" ")}>
                        <ImageText {...componentData} />
                    </div>
                );
            }
            case "mediagallery": {
                classList.push("col-md-10 col-lg-8");
                return (
                    <div className={classList.join(" ")}>
                        <MediaGallery
                            title={componentData.title}
                            description={componentData.description}
                            media={componentData.media}
                        />
                    </div>
                );
            }
            case "accordions": {
                classList.push("col-md-10 col-lg-8");
                return (
                    <div className={classList.join(" ")}>
                        <Accordions
                            title={componentData.title}
                            description={componentData.description}
                            accordions={componentData.sections}
                        />
                    </div>
                );
            }
            case "icons": {
                classList.push("col-md-10 col-lg-8");
                return (
                    <div className={classList.join(" ")}>
                        <IconRow
                            icons={componentData.icons}
                            title={componentData.title}
                            description={componentData.description}
                        />
                    </div>
                );
            }
            case "marketing_form": {
                classList.push("col-xs-12 col-md-8 col-lg-5");
                return (
                    <div className={classList.join(" ")}>
                        <RTMForm {...componentData} />
                    </div>
                );
            }
            case "leaderboard_ads": {
                classList.push("col-md-10 col-lg-9");
                const leaderboard = component.leaderboard_ad
                    ? getContentReferenceTileProps(
                          addACFData(component.leaderboard_ad)
                      )
                    : null;
                return (
                    <div className={classList.join(" ")}>
                        {leaderboard && (
                            <Leaderboard
                                imageDesktop={leaderboard.image_desktop}
                                imageMobile={leaderboard.image_mobile}
                                alt={leaderboard.title}
                                link={leaderboard.url}
                                position="builder"
                            />
                        )}
                    </div>
                );
            }
            case "whats_on": {
                classList.push("col-md-10 col-lg-9");
                return (
                    <div className={classList.join(" ")}>
                        <WhatsOn componentData={componentData} />
                    </div>
                );
            }
            default: {
                return <pre>{JSON.stringify(componentData, null, 2)}</pre>;
            }
        }
    };
    return (
        <div className="component-builder container-fluid">
            {components.map((component: any, index: number): any => {
                const classList = ["component-builder__component row"];
                classList.push(
                    `component-builder__component--${component.acf_fc_layout}`
                );
                return (
                    <div
                        className={classList.join(" ")}
                        style={{ textAlign: "left" }}
                        key={index}
                    >
                        {renderSingleComponent(component)}
                    </div>
                );
            })}
        </div>
    );
};

export default ComponentBuilder;
